import http from '@/plugins/axios/axios';

export default class DispositivoService {

    validar(requisicao) {       
        return http.post('/api/v1/app/dispositivo/validar', requisicao);
    }

    ativar(requisicao) {       
        return http.post('/api/v1/app/dispositivo/ativar', requisicao);
    }

}